export default {
  clearFilter({ commit }) {
    commit("setFilterStartDate", "")
    commit("setFilterEndDate", "")
    commit("setExportationTypes", [])
  }
}
